import { TreeNode } from "primeng/api";

export class TreeModel implements TreeNode {

    public label: string;
    public data: any;
    public expandedIcon: string;
    public collapsedIcon: string;
    public icon: string;
    public children: TreeModel[] = [];
    public parent: TreeModel;
    public leaf?: boolean;
    public _type: string;
    public selectable: boolean;
    public expanded: boolean;
    public partialSelected: boolean;
    public fullPath: string;
    // aux properties
    public inspected = false;
    public isTopLevel = false;
    public isFolder = false;
    public isSubfolder = false;
    public warning: boolean;
    public isFile = false;
    public isSelected = false;

    constructor(item: any = {}) {
        this.label = item.label;
        this.data = item.data;
        this.expandedIcon = item.expandedIcon;
        this.collapsedIcon = item.collapsedIcon;
        this.icon = item.icon;
        this.children = item.children || [];
        this.isTopLevel = item.isFolder || false;
        this.isFolder = item.isFolder || false;
        this.parent = item.parent;
        this.type = item.type || 'default';
        this.warning = item.warning || false;
        this.partialSelected = null;
        this.inspected = item.inspected;
        this.selectable = item.selectable;
        this.expanded = item.expanded;
        this.leaf = item.leaf;
        this.isFile = item.isFile;
        this.fullPath = item.fullPath || '';
        this.isSelected = item.isSelected || false;
    }

    get type() {
        return this._type;
    }

    set type(type) {
        this._type = type;
    }
}
